import { render, staticRenderFns } from "./gj-log-modal.vue?vue&type=template&id=51569de6&scoped=true&"
import script from "./gj-log-modal.vue?vue&type=script&lang=js&"
export * from "./gj-log-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-log-modal.vue?vue&type=style&index=0&id=51569de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51569de6",
  null
  
)

export default component.exports